
$controllers.profilesettings = {
	
	onUnload : function() {
		$controllers.all.unbindEnterFormSubmissions();
	},
	
	display : function() {
		
		if (!$controllers.all.enforcePagePermissions('profilesettings')) { return false; }
		$controllers.all.showPage('profilesettings', 'contentpage');
		$controllers.all.setNavigation();
		$views.profilesettings.display();
		$controllers.all.handleEnterFormSubmissions();
		
	},
	
	save : function() {
		
		// get data from form
		$formData = { user: jQuery('#profile-form').serializeObject() };
		delete $formData.user.status;
		delete $formData.user.user_role_label;
		delete $formData.user.email;
		delete $formData.user.password2;
		
		// quick validation
		if (!$models.profilesettings.validateFormData()) {
			return false;
		}
		
		// save changes
		$models.users.setMyData($formData, function() {
			$soupmail.notification.message('User profile changes have been saved successfully');
		});
		
	},
	
	removeAccount : function() {
		
		jQuery('#warning_message').text('Please wait while we securely remove your account and all your data, this may take a little while...');
		
		$models.users.deleteItem($models.login.getUserid(), function() {
			$controllers.login.logout(false);
			$soupmail.notification.message('User account has been removed');
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.profilesettings.js